import React, { useEffect, useRef, useState } from "react";
import classes from "./DragCards.module.css";
import Card from "./Card";
import TitleHeader from "./TitleHeader";

const DragCards = ({ data , main_category_id,sub_category_id}) => {
  const scrollRef = useRef(null);
  const [hover, setHover] = useState(false);

  const scrollFunc = (direction) => {
    if (scrollRef.current) {
      if (direction === "left") {
        scrollRef.current.scrollBy({
          // left: -300,
          left: -window.innerWidth,
          behavior: "smooth",
        });
      } else if (direction === "right") {
        scrollRef.current.scrollBy({
          // left: 300,
          left: window.innerWidth,
          behavior: "smooth",
        });
      }
    }
  };

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScrollPosition = () => {
    const element = scrollRef.current;
    if (element) {
      setCanScrollLeft(element.scrollLeft > 0);
      setCanScrollRight(
        element.scrollLeft < element.scrollWidth - element.clientWidth - 10
      );
    }
  };

  useEffect(() => {
    const element = scrollRef.current;
    if (element) {
      element.addEventListener("scroll", checkScrollPosition);
      checkScrollPosition();

      return () => {
        element.removeEventListener("scroll", checkScrollPosition);
      };
    }
  }, []);
  return (
    <>
      <div className={classes.arrows_container}>
        {canScrollLeft && (
          <div
            className={`${classes.left_arrow} ${!hover && classes.inactive}`}
            onClick={() => scrollFunc("left")}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            <i className={`pi pi-chevron-left ${classes.left_icon}`}></i>
          </div>
        )}

        {canScrollRight && (
          <div
            className={`${classes.right_arrow} ${!hover && classes.inactive}`}
            onClick={() => scrollFunc("right")}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            <i className={`pi pi-chevron-right ${classes.right_icon}`}></i>
          </div>
        )}
      </div>

      <div
        className={`${classes.drag_section}`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        ref={scrollRef}
        style={{ gridTemplateColumns: `repeat(${data?.length},150px)` }}
      >
        {data?.map((dataItem, idx) => {
          return (
            <React.Fragment key={idx}>
              <Card dataItem={dataItem} episode={idx} main_category_id={main_category_id} sub_category_id={sub_category_id} />
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default DragCards;
